module.exports = __webpack_public_path__ + "static/media/pr-5.d0a5f1a1.jpg";